<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark" header="Video Player">
        <h1>ID: {{ $route.params.link }}</h1>
        <video-player class="vjs-custom-skin vh-100"
                      ref="videoPlayer"
                      :options="playerOptions"
        >
        </video-player>
      </b-card>
    </Content>
  </content-wrapper>
</template>

<script>
// require styles
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css'
import ContentWrapper from "@/components/Layouts/ContentWrapper";
import Content from "@/components/Layouts/Content";
import VideoPlayer from "@/components/VideoPlayer";
export default {
  name: "Stream",
  components: {
    Content, ContentWrapper,
    VideoPlayer,
  },
  data: ()=>({
    playerOptions: {
      autoplay: false,
      controls: true,
      // techOrder: ['flash', 'html5'],
      sourceOrder: true,
      flash: { hls: { withCredentials: false } },
      html5: { hls: { withCredentials: false } },
      sources: [{
        type: 'application/x-mpegURL',
        src: 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8'
      }],
    },
  }),
  created() {
    console.log('created')
  },
  methods: {
    // listen event
  },
}
</script>

<style scoped>

</style>
